import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import AuctionListCtrl from '../../../components/reportsComponents/storagemanagement/auctionListCtrl';
import AuctionListTable from '../../../components/reportsComponents/storagemanagement/auctionListTable';
const pageTitle = 'Auction List'
let AuctionListForm={
	formAuctionListInfo:{}
}

class AuctionList extends Component {
	constructor() {
		super();
		this.state = {
		}
	}
	componentWillMount = () => {
		document.title = pageTitle;
		
    }
	render() {
		return (
            <Fragment>
                <div className="page-header">
                    <div className="row mb-10">
                        <div className="col-md-12 col-sm-12">
                            <div className="title">
                                <h4> Auction List</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pd-10 bg-white border-radius-4 box-shadow">
                    <AuctionListCtrl 
                    initCallBack={(frm)=>{
						AuctionListForm.formAuctionListInfo=frm;
                    }}/>
                    <AuctionListTable />
                </div>
            </Fragment>
		);
	}
}
const mapStateToProps = (state, ownProps) => {
	return {
		
	}
};

export default withRouter(connect(mapStateToProps)(AuctionList));
